"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GenericDisplayCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _genericIdentifier = _interopRequireDefault(require("./genericIdentifier"));
var _genericRowsOfDetails = _interopRequireDefault(require("./genericRowsOfDetails"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * GenericDisplayCard generates a card with up to three general columns:
 *  firstSection: displays a single column of titles and contents
 *  middleSection: displays an array of titles an corresponding contents
 *     in a specified number of columns
 *  lastSection: displays a child component
 *
 * The sum of the column widths must be 16 or less.  If a column width is
 * omitted, that section will not be displayed
 *
 * PROPS:
 *     firstSectionTitles: an array of titles to display
 *     firstSectionContents: an array of items to display below the titles. The
 *                           items may include components such as links
 *     firstSectionWidth: width of the first section (1-16)
 *     middleSectionTitles: an array of titles to display
 *     middleSectionContents: an array of items to display below the titles. The
 *                           items may include components such as links
 *     middleSectionWidth: width of the middle section (1-16)
 *     middleSectionColumns: number of columns to display within the middle section
 *     lastSectionWidth: width of the last section (1-16)
 *     children: component to render in the last section
 */
var GenericDisplayCard = function GenericDisplayCard(_ref) {
  var firstSectionTitles = _ref.firstSectionTitles,
    firstSectionContents = _ref.firstSectionContents,
    firstSectionWidth = _ref.firstSectionWidth,
    middleSectionTitles = _ref.middleSectionTitles,
    middleSectionContents = _ref.middleSectionContents,
    middleSectionWidth = _ref.middleSectionWidth,
    middleSectionColumns = _ref.middleSectionColumns,
    lastSectionWidth = _ref.lastSectionWidth,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Card, {
    className: "grid-display-card",
    fluid: true
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
    mobile: 16,
    computer: 12,
    align: "left"
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
    className: "grid-display-card",
    columns: 3,
    divided: true
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, {
    width: "100%"
  }, firstSectionWidth ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
    id: "identifier-column",
    width: firstSectionWidth
  }, /*#__PURE__*/_react.default.createElement(_genericIdentifier.default, {
    titles: firstSectionTitles,
    contents: firstSectionContents
  })) : null, middleSectionWidth ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
    id: "details-column",
    width: middleSectionWidth
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
    className: "grid-display-card"
  }, /*#__PURE__*/_react.default.createElement(_genericRowsOfDetails.default, {
    titles: middleSectionTitles,
    contents: middleSectionContents,
    columns: middleSectionColumns
  }))) : null, lastSectionWidth ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
    id: "actions-column",
    width: lastSectionWidth,
    className: ""
  }, children) : null)))), /*#__PURE__*/_react.default.createElement("br", null));
};
exports.GenericDisplayCard = GenericDisplayCard;
var _default = GenericDisplayCard;
exports.default = _default;